import { Modal } from "antd";
import BoxListChart from "components/StockAnalysis/components/BoxListChart";
import { useDispatch, useSelector } from "react-redux";
import { setShowModal } from "store/actionReducers/StocksAnalysisStore";

import iconClose from '../.././assets/images/ModalStocksAnalysis/icon-close.png'

import './ModalStocksAnalysis.scss'

export default function ModalStocksAnalysis() {
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);
  const dispatch = useDispatch();

  const handleColspan = () => {
    dispatch(setShowModal())
  };

  return (
    <>
      <Modal className="peniqsypnt" title="" footer={false} closable={false}
        width={'75vw'}
        visible={StocksAnalysisStore?.showModal}
        onOk={handleColspan}
        onCancel={handleColspan}>
        <BoxListChart />
        <div className="xkglvcvkoc" onClick={() => handleColspan()}><img src={iconClose} alt="" className="fxgvcjoyov" /></div>
      </Modal>
    </>
  )
}